import AddDocumentModal from './AddDocumentModel';

export default AddDocumentModal;
